import { OverView } from '@/features/payment-management/overview';
import { createFileRoute, SearchSchemaInput } from '@tanstack/react-router';
import { z } from 'zod';

const sortItemSchema = z.object({
  id: z.enum(['month', 'numberOfCustomer', 'numberOfStore', 'numberOfAffiliate', 'receiveAmount']),
  desc: z.boolean(),
});

const storesLogSchema = z.object({
  sort: z
    .preprocess((val) => {
      if (typeof val === 'string') {
        try {
          return JSON.parse(val);
        } catch {
          return undefined;
        }
      }
      return val;
    }, z.array(sortItemSchema))
    .optional(),

  createdDate: z
    .string()

    .optional(),

  q: z
    .any()
    .transform((val) => (val == null ? undefined : String(val)))
    .optional(),

  status: z
    .string()
    .transform((val) => val.split(','))
    .pipe(z.array(z.enum(['ACTIVE', 'BLOCKED'])))
    .optional(),

  page: z.coerce.number().positive().catch(0),
  fetch: z.coerce.number().positive().max(100).catch(10),
});

export const Route = createFileRoute('/(app)/payment-management/overview/')({
  component: RouteComponent,
  validateSearch: (search: SearchSchemaInput) => storesLogSchema.parse(search),
});

function RouteComponent() {
  return <OverView />;
}
